module.exports = __webpack_public_path__ + "static/media/champion.b9e0fe13.otf";